const hostResolver = () => {
    if (window.env.REACT_APP_BACKEND_URL !== "") {
        return window.env.REACT_APP_BACKEND_URL
    }    
    return ""
}
export const BE_ADDR = hostResolver()